import { useTheme } from '@mui/material/styles';
import { createMakeStyles } from 'tss-react';

export const { makeStyles, useStyles } = createMakeStyles({ useTheme });
